var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('img',{attrs:{"src":_vm.phone_upload_img,"alt":""},on:{"click":_vm.openPhoto}})])])}
var staticRenderFns = []

export { render, staticRenderFns }